<template>
  <sp-expandable-area title="Model Console" class="root">
    <pre>{{ model }}</pre>
  </sp-expandable-area>
</template>

<script setup>
defineProps({
  model: {
    type: Object,
    default: () => ({}),
  },
});
</script>

<style lang="scss" scoped>
pre {
  background: #000;
  color: #fff;
  padding: 1rem;
  border-radius: 5px;
  font-size: small;
  width: 100%;
  min-height: 300px;
  overflow-y: auto;
}
.root {
  --sp-comp-expandable-area-activator-color: #bbb;
  --sp-comp-expandable-area-activator-font-weight: 600;
}
</style>
